export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const editIcon = require("../assets/edit_icon.svg")
export const saveIcon = require("../assets/save_icon.svg")
export const cancelIcon = require("../assets/cancel_icon.svg")
